export default {
  private: {
    title: 'Private Kintell Meeting',
    summary: 'Please book a Kintell meeting with me using this card. I\'d appreciate it if you could: \n\n' +
      '* Let me know the context of your booking and the topic you would like to discuss with me in your booking request.\n\n' +
      '* Book a 30 min session unless we have agreed on a longer time slot.\n\n' +
      'Thank you for getting in touch and I look forward to our meeting!'
  },
  edit: {
    errors: {
      skills: {
        minLength: 'Oops! Please enter a minimum of {min} related skills :)',
        maxLength: 'Ah sorry we limit the amount of skill tags to {max}'
      },
      title: {
        notInArray: 'Oops! Looks like you already have a Kintell Card with this Topic.'
      },
      minLength: 'Oops! It looks like you’re below our character minimum. We like to keep our Kintell Card {field} fields to over {min} characters :)',
      maxLength: 'Oops! It looks like you’ve hit our character limit. We like to keep our Kintell Card {field} fields to under {max} characters, to keep things simple and snappy :)',
      advisingIn: {
        minLengthNotEmpty: 'Oops! We like to keep our Kintell Cards to having at least {min} Advising In fields :)'
      },
      categories: {
        minLength: 'Oops! Please enter a minimum of {min} categories :)',
        maxLength: 'Oops!, You reached your limit of {max} categories :)'
      },
      rate: {
        maxValue: 'Sorry, the highest rate you can set is {currency}{max} / 30 mins :)',
        kintellCardRate: 'Sorry, the lowest rate you can set is {currency}15 / 30 mins or FREE :)',
        kintellCardNoPayouts: 'Sorry, since we don\'t support payouts in your country currently, you can only set the rate to $0.',
      }
    },
    placeholders: {
      title: 'Your Card Title',
      advisingIn: 'Advising In',
      summary: 'Describe the service you will be offering as an advisor and relevant experience.',
    },
    hints: {
      title: 'E.g. Web Designer, English Teacher, or Aviation Advisor.',
      socialLink: 'Select the social network for this card',
      supportingLinks: {
        description: '(optional)'
      }
    }
  },
  // k-layout-split-image-left
  sentForReview: {
    title: 'Nearly there!',
    subtitle: 'As this is your first Kintell Card, we’ve sent it to The Kintell Team to review it before it goes live.',
    nextSteps: {
      steps: [
        { step: 'You should hear back from The Kintell Team as soon as they have approved it' },
        { step: 'If it needs tweaking in any way they’ll let you know how' },
        { step: 'Once it’s live you can start taking bookings straight away!' },
      ]
    }
  },
  ghostCards: [
    {
      rate: 68,
      title: 'Craft Beer Brewing',
      summary: 'Our small team started brewing pale ale in our micro-brewery 5 years ago. Moving steadily from producing one barrel a month, our current brew length (amount of beer per brew) is 6HL (600 litres), per quarter. We have now grown to a team of 8 dedicated connoisseurs, perfecting our craft to produce award-winning ale. \n\n' +
        'If you’re looking to tap into years of brewing experience and would like to taste what it\'s like to turn a garage project into a thriving and scalable business, reach out for a consultation.',
      skills: [
        'Milling and Mashing',
        'Tasting',
        'Beer Chemistry'
      ],
      status: 'published',
      stats: {
        reviewsCount: 5,
        reviewsAverage: 4,
      },
      advisingIn: [
        'Craft beer history in Australia & New Zealand',
        'Brewing & branding market ready craft beer',
        'Balancing malt & hop profiles',
        // Repeating because we have three hidden fields
        'Craft beer history in Australia & New Zealand',
        'Brewing & branding market ready craft beer',
      ]
    },
    {
      rate: 75,
      stats: {
        reviewsCount: 0,
        reviewsAverage: 0,
      },
      title: 'Esports Coaching',
      status: 'unlisted',
      summary: 'Since high school, I have developed an everlasting love for clan gaming :) \n\n' +
        'Streaming and competing for 5 years now, I have over 50,000 Twitch followers. My subscriptions continue to grow every month and generate income weekly. If you want to become a professional gamer or even an E-sports Coach like me, I have years of experience and wisdom that you could tap into. \n\n' +
        'Reach out for a consultation and I can offer coaching tips, effective scrim design, and team management advice.',
      skills: [
        'League of Legends',
        'Teamwork',
        'Strategy'
      ],
      advisingIn: [
        'Building a team culture & E-team management',
        'Designing effective training for competition',
        'Creating unique strategies and following meta',
        // Repeating because we have three hidden fields
        'Building a team culture & E-team management',
        'Designing effective training for competition',

      ]
    },
    {
      rate: 15,
      title: 'Vegan Food',
      stats: {
        reviewsCount: 0,
        reviewsAverage: 0,
      },
      status: 'published',
      summary: 'I am a passionate and experienced vegan cook!\n\n' +
        'Living by the principles of eliminating processed food, making cooking easy and striving to only use affordable organic ingredients, my experiences will support you in creating beautifully presentable and nutritious fusion cuisine. \n\n' +
        'If you need ideas or inspiration using fresh natural ingredients, I can help!',
      skills: [
        'Vegan Cooking',
        'Nutrition',
        'Food Presentation'
      ],
      advisingIn: [
        'Asian & Iranian fusion: Design considerations',
        'Colorful, appetising & simple vegan cooking',
        'The history of organic Asian cuisine',
        // Repeating because we have three hidden fields
        'Asian & Iranian fusion: Design considerations',
        'Colorful, appetising & simple vegan cooking',
      ]
    },
    {
      rate: 30,
      title: 'Astronaut',
      stats: {
        reviewsCount: 11,
        reviewsAverage: 4.5,
      },
      status: 'published',
      summary: 'I have 15 years of experience working for NASA and SpaceX. I am passionate about space exploration and embracing the unknown universe. \n\n' +
        'I have a degree in Aerospace Engineering. Over the years I have accumulated a wealth of knowledge preparing teams for future missions, teaching them how to handle high-stress environments and solve complicated engineering and human-in-the-loop problems. \n\n' +
        'I can offer advice to explore your own path to become a successful Astronaut.',
      skills: [
        'Piloting spacecraft',
        'SpaceX',
        'NASA'
      ],
      advisingIn: [
        'Developing pre & post mission mental fitness ',
        'Atmospheric entry - key control considerations',
        'Long-duration astronaut physical examination',
        // Repeating because we have three hidden fields
        'Developing pre & post mission mental fitness ',
        'Atmospheric entry - key control considerations',
      ]
    },
    {
      rate: 0,
      stats: {
        reviewsCount: 0,
        reviewsAverage: 0,
      },
      title: 'Fortune Cookie Writer',
      status: 'unlisted',
      summary: 'Spending thousands of hours writing thought-provoking sentences has led me to my own good fortunes!\n\n' +
        'Over many years I’ve developed a method for writing succinct motivational phrases, that entertain and encourage readers the world over. Occasionally, I even stumble across some of my own cookie creations! \n\n' +
        'I’d be happy to share my experiences with you and let you in on the secrets of being a successful and engaging writer, no matter what genre.',
      skills: [
        'Humour',
        'Communication',
        'Inspiration'
      ],
      advisingIn: [
        'Creative writing & imaginative writing',
        'Humorous writing & one-line engagement',
        'The power of similes in descriptive writing',
        // Repeating because we have three hidden fields
        'Creative writing & imaginative writing',
        'Humorous writing & one-line engagement',
      ]
    },
    {
      rate: 60.00,
      stats: {
        reviewsCount: 67,
        reviewsAverage: 5,
      },
      status: 'published',
      title: 'Motion Creative',
      summary: 'I have worked in the Broadcasting and TV industry for many years as a Design Lead and Motion Graphic Designer, turning ideas into visually stunning motion graphics. \n\n' +
        'Collaborating with various advertising agencies and production companies throughout my career, I’ve spearheaded a number of award-winning projects, such as Tron - Uprising. \n\n' +
        'Feel free to hit me up! I would love to share my experience with you.',
      skills: [
        'CGI',
        'Adobe suite',
        'Final Cut Pro'
      ],
      advisingIn: [
        'Motion graphics research & design',
        'Broadcast media programming & scheduling',
        'Computer Generated Imagery (CGI) ',
        // Repeating because we have three hidden fields
        'Motion graphics research & design',
        'Broadcast media programming & scheduling',
      ]
    },
    {
      rate: 0,
      stats: {
        reviewsCount: 0,
        reviewsAverage: 0,
      },
      status: 'published',
      title: 'Game of Thrones',
      summary: 'I have watched all 8 seasons of GOT passionately and read all of the books. Big fan! \n\n' +
        'Game of Thrones is the story of different houses in Westeros fighting and conspiring to win the Iron Throne in King’s Landing. It’s a great piece in terms of strategy (a more entertaining version of  ‘The Art of War’ by Sun Tzu). It has a massive ensemble cast and allthough several plots are full of violence and sex, there is a deeper message when you step back to analyse the story. Each character is thoroughly developed, even those that get killed unexpectedly. Although there are some controversy about season 8, the overall experience of GOT is engaging and educational and I’d be happy to talk to you about it! \n\n' +
        'Book me for a chat and I can tell you anything you need to know about GOT.\n',
      skills: [
        'GOT',
        'Whitewalkers origin',
        'Westeros'
      ],
      advisingIn: [
        'Targaryens, Lannisters, Starks',
        'Why GOT is a must-see for strategy',
        'Analysing character decisions',
        // Repeating because we have three hidden fields
        'Targaryens, Lannisters, Starks',
        'Why GOT is a must-see for strategy',
      ]
    },
    {
      rate: 38,
      stats: {
        reviewsCount: 0,
        reviewsAverage: 0,
      },
      status: 'draft',
      title: 'Sneaker Collecting',
      summary: 'Starting with one pair of Nike Air Max 90s, I was able to trade, sell and purchase my way to owning an award-winning boutique sneaker collection.  \n\n' +
        'I have contributed content to a number of sneaker magazines and exhibited my collection in a number of leading galleries. I have even consulted for the Brooklyn Museum exhibit ‘The Rise of Sneaker Culture’. \n\n' +
        'Need some advice on how to get started? Maybe you’re interested in sneaker culture and history - Hit me up!',
      skills: [
        'Hype ',
        'Street style',
        'Nike vs Adidas'
      ],
      advisingIn: [
        'Purchasing and trading sneakers',
        'Exhibiting sneakers in competitions',
        'Enhancing the value of your collection',
        // Repeating because we have three hidden fields
        'Purchasing and trading sneakers',
        'Exhibiting sneakers in competitions',
      ]
    }
  ],
}
